const AboutUsFooter = () => {
  window.scrollTo(0, 0);
  return (
    <>
      <div className="container mt-4 mb-5" style={{ minHeight: "70vh" }}>
        <h2 className="text-center text-primary-new fw-bold mb-4 mt-5">About Us</h2>
        <p className="text-dark">
          Reachello is a guest post marketplace specializing in the health and
          wellness industry; connecting clinics, hospitals and marketing
          agencies with high quality publishers. We are proud to host the
          largest selection of premium high-authority health and wellness
          publishers in the world.
          <br />
          <br />
          While we make outreach simple by automating communication between
          publishers and marketers, we don't automate support.
          <br />
          <br />
          Create your account now and grow with Reachello!
        </p>
      </div>
    </>
  );
};

export default AboutUsFooter;
